import setCalendarProcessingOperation from 'owa-service/lib/operation/setCalendarProcessingOperation';
import setCalendarProcessingRequest from 'owa-service/lib/factory/setCalendarProcessingRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';

/**
 * Service call to set calendar processing options
 */

export default function setCalendarProcessingOptions(
    options: CalendarProcessingOptions
): Promise<OptionsResponseBase> {
    return setCalendarProcessingOperation(
        setCalendarProcessingRequest({
            Header: getJsonRequestHeader(),
            Options: options,
        })
    );
}
